import { UPLOAD_ALLOWED_FILE_FORMAT } from './common.constants';

export const Messages = {
  error: {
    ErrorMsg: 'Something went wrong, please try again.'
  },
  WORKORDER: {
    success_wo_send: 'You have successfully send workorder.',
  },
  ROLES: {
    CONSUMER_SUPER_ADMIN: 'ROLE_CONSUMER_SUPER_ADMIN',
    PROVIDER_SUPER_ADMIN: 'ROLE_PROVIDER_SUPER_ADMIN'
  },
  PROFILE: {
    success_changePassword: 'You have successfully changed your password.',
  },
  USER: {
    success_user: 'You have successfully added user.',
    update_user: 'You have successfully updated user.',
  },
  HOLIDAYS: {
    success_holiday: 'You have successfully added holiday.',
  },
  Login: {
    invalid_email: 'You have not enter valid email address.',
    email_exits: 'This email address is already exits.',
    user_exits: 'This username is already exits.',
    email_not_exists: 'Email address not registered',
    email_not_registered: 'Email address is not registered.',
    forgot_Password_Success: 'Check your email for details on how to reset your password.',
    key_missing_message: 'Key is Missing.',
    reset_Password_Success: 'You have successfully updated your account password.',
    invalid_ResetKey: 'No user was found for this reset key',
    invalid_login: 'Failed to sign in! Please check your credentials and try again.',
  },
  ErrorMsg: {
    invaldPassword: 'Incorrect password',
    emailnotreg: 'Email address not registered',
    emailused: 'Email is already in use!',
    usernameused: 'Login name already used!',
    session_timeout: 'Your account is inactivated, please contact admin.',
    token_expired: 'Your session is expired. Relogin to continue.',
    nodata: 'No data found',
    device_unreachable: 'Device unreachable.',
    ErrorFieldRequired: 'Field is Required.',
    ErrorMaxFileSize: 'File Size Should Not Be More Than 10MB!',
    ErrorSupportedFileFormat: 'Only Supported file format are ' + UPLOAD_ALLOWED_FILE_FORMAT
  },
  PopupSize: {
    popup_lg: '1000px',
    popup_md: '800px',
    popup_sm: '300px',
    popup_xmd: '600px'
  },
  DeviceConfigurations: {
    updateSuccess: 'Configurations Updated.',
    configFinal: 'Configurations Finalized.',
    minimumPorts: 'Minimum 4 ports should be selected',
    selectBandwidth: 'Please select bandwidth of quadrant ',
    selectPolarization: 'Please select polarization of quadrant ',
    finalizeConfigAlert: 'Your default configurations will be changed and this will be your permanent configuration. Do you want to continue?'
  },
  DeviceDetails: {
    NO_ADDRESS: 'No address available!'
  },
  successMsg: {
    SuccessFileUpload: 'You have successfully uploaded file.',
    SuccessFirmwareRequest: 'You have successfully sent firmware.'
  },
  tooltip_msg: {
    DEVICE_STATUS_MAC_ADDRESS: 'Device status needs to be active and mac should match to use the device.',
    DEVICE_STATUS: 'Device status needs to be active to the device.'
  },
  DELETE_MODAL: {
    TITLE: {
      CUSTOMER: 'Delete Customer',
      DEVICE: 'Delete Device'
    },
    DESCRIPTION: {
      CUSTOMER: 'Are you sure you want to delete this customer?',
      DEVICE: 'Are you sure you want to delete this device?'
    }
  }
};
